export const DOC_ERROR_TYPE = {
    CORRUPT_IMAGE: 'CORRUPT_IMAGE',
    MITEK_ERROR_CORRUPT_IMAGE: 'MITEK_ERROR_CORRUPT_IMAGE',
    FOUR_CORNER: 'FOUR_CORNER',
    MITEK_ERROR_FOUR_CORNER: 'MITEK_ERROR_FOUR_CORNER',
    TOO_DARK: 'TOO_DARK',
    MITEK_ERROR_TOO_DARK: 'MITEK_ERROR_TOO_DARK',
    FOCUS: 'FOCUS',
    MITEK_ERROR_FOCUS: 'MITEK_ERROR_FOCUS',
    GLARE: 'GLARE',
    MITEK_ERROR_GLARE: 'MITEK_ERROR_GLARE',
    MIN_PADDING: 'MIN_PADDING',
    MITEK_ERROR_MIN_PADDING: 'MITEK_ERROR_MIN_PADDING',
    TOO_CLOSE: 'TOO_CLOSE',
    MITEK_ERROR_TOO_CLOSE: 'MITEK_ERROR_TOO_CLOSE',
    IMAGE_SMALLER_THAN_MIN_SIZE: 'IMAGE_SMALLER_THAN_MIN_SIZE',
    MITEK_ERROR_IMAGE_SMALLER_THAN_MIN_SIZE: 'MITEK_ERROR_IMAGE_SMALLER_THAN_MIN_SIZE',
    HORIZONTAL_FILL: 'HORIZONTAL_FILL',
    MITEK_ERROR_HORIZONTAL_FILL: 'MITEK_ERROR_HORIZONTAL_FILL',
    TOO_FAR: 'TOO_FAR',
    MITEK_ERROR_TOO_FAR: 'MITEK_ERROR_TOO_FAR',
    SKEW_ANGLE: 'SKEW_ANGLE',
    MITEK_ERROR_SKEW_ANGLE: 'MITEK_ERROR_SKEW_ANGLE',
    LOW_CONTRAST: 'LOW_CONTRAST',
    MITEK_ERROR_LOW_CONTRAST: 'MITEK_ERROR_LOW_CONTRAST',
    BUSY_BACKGROUND: 'BUSY_BACKGROUND',
    MITEK_ERROR_BUSY_BACKGROUND: 'MITEK_ERROR_BUSY_BACKGROUND',
    MRZ_MISSING: 'MRZ_MISSING',
    MITEK_ERROR_MRZ_MISSING: 'MITEK_ERROR_MRZ_MISSING',
    PERPENDICULAR_DOCUMENT: 'PERPENDICULAR_DOCUMENT',
    MITEK_ERROR_PERPENDICULAR_DOCUMENT: 'MITEK_ERROR_PERPENDICULAR_DOCUMENT',
    NOT_CENTRED: 'NOT_CENTRED',
    MITEK_ERROR_NOT_CENTRED: 'MITEK_ERROR_NOT_CENTRED',
};
export const SELFIE_ERROR_TYPE = {
    MISNAP_HEAD_OUTSIDE: 'MISNAP_HEAD_OUTSIDE',
    MITEK_ERROR_MISNAP_HEAD_OUTSIDE: 'MITEK_ERROR_MISNAP_HEAD_OUTSIDE',
    MISNAP_HEAD_SKEWED: 'MISNAP_HEAD_SKEWED',
    MITEK_ERROR_MISNAP_HEAD_SKEWED: 'MITEK_ERROR_MISNAP_HEAD_SKEWED',
    MISNAP_AXIS_ANGLE: 'MISNAP_AXIS_ANGLE',
    MITEK_ERROR_MISNAP_AXIS_ANGLE: 'MITEK_ERROR_MISNAP_AXIS_ANGLE',
    MISNAP_HEAD_TOO_CLOSE: 'MISNAP_HEAD_TOO_CLOSE',
    MITEK_ERROR_MISNAP_HEAD_TOO_CLOSE: 'MITEK_ERROR_MISNAP_HEAD_TOO_CLOSE',
    MISNAP_HEAD_TOO_FAR: 'MISNAP_HEAD_TOO_FAR',
    MITEK_ERROR_MISNAP_HEAD_TOO_FAR: 'MITEK_ERROR_MISNAP_HEAD_TOO_FAR',
    MISNAP_STAY_STILL: 'MISNAP_STAY_STILL',
    MITEK_ERROR_MISNAP_STAY_STILL: 'MITEK_ERROR_MISNAP_STAY_STILL',
    MISNAP_READY_POSE: 'MISNAP_READY_POSE',
    MITEK_ERROR_MISNAP_READY_POSE: 'MITEK_ERROR_MISNAP_READY_POSE',
    MISNAP_STOP_SMILING: 'MISNAP_STOP_SMILING',
    MITEK_ERROR_MISNAP_STOP_SMILING: 'MITEK_ERROR_MISNAP_STOP_SMILING',
    MISNAP_SMILE: 'MISNAP_SMILE',
    MITEK_ERROR_MISNAP_SMILE: 'MITEK_ERROR_MISNAP_SMILE',
    NO_FACE_FOUND: 'NO_FACE_FOUND',
    MITEK_ERROR_NO_FACE_FOUND: 'MITEK_ERROR_NO_FACE_FOUND',
    MITEK_ERROR_GLARE: 'MITEK_ERROR_GLARE',
    MITEK_ERROR_MITEK_ERROR_GLARE: 'MITEK_ERROR_MITEK_ERROR_GLARE',
    MITEK_ERROR_TOO_DARK: 'MITEK_ERROR_TOO_DARK',
    TOO_DARK: 'TOO_DARK',
    MITEK_ERROR_FOCUS: 'MITEK_ERROR_FOCUS',
    MITEK_ERROR_MITEK_ERROR_FOCUS: 'MITEK_ERROR_MITEK_ERROR_FOCUS',
    MITEK_ERROR_COMMON: 'MITEK_ERROR_COMMON',
};
export const JOURNEY_EVENT = {
    BUTTON_CLICK: 'Button Click',
    EXTERNAL_LINK: 'External Click',
    INTERNAL_CLICK: 'Internal Click',
    FORM_ENTRY: 'Form Entry',
    FIELD_UPDATE: 'Field Update',
    PAGE_SUBMIT: 'Page Submit',
    ACCORDION_CLICK: 'Accordion Click',
    TARRIF: 'New Applicant',
    TARRIF_RETURNER: 'Returner',
    ADDONS: 'Startup',
};
export const TAGGING_FIELDS = {
    SUBMIT: 'Continue',
    BACK: 'Previous',
    PROOF_IDENTITY_SELECTED_OPTION: 'Photo ID: ',
    PASSPORT_COUNTRY_OF_ISSUE: 'Passport country of issue',
    BIO_METRIC_STATUS: 'Biometric check: ',
    CONFIRM_CHECKBOX_SELFIE: 'Confirm Checkbox for selfie: ',
    NEED_HELP: 'Need help',
    PRIVACY_POLICY_LINK: 'Privacy Policy',
    VALIDATION_ERROR: 'Validation error',
};
export const generateLinkValue = (taggingLabel) => {
    const taggingLabelWithoutSpace = taggingLabel.split(/[\s:]+/).join('');
    return `button/${taggingLabelWithoutSpace.toLowerCase()}`;
};
export const getJourneyTariff = sessionStorage.getItem('isOldUser') === 'true'
    ? JOURNEY_EVENT.TARRIF_RETURNER
    : JOURNEY_EVENT.TARRIF;
//# sourceMappingURL=index.js.map